var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_264_785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 7.50065C8.6625 7.50065 7.375 7.70898 6.16667 8.10065V10.6882C6.16667 11.0173 5.975 11.3007 5.7 11.4382C4.8875 11.8465 4.14167 12.3673 3.47917 12.9798C3.32917 13.1257 3.125 13.2173 2.89583 13.2173C2.66667 13.2173 2.45833 13.1257 2.30833 12.9715L0.245833 10.909C0.0916667 10.7548 0 10.5465 0 10.3173C0 10.0882 0.0916667 9.87982 0.245833 9.72565C2.78333 7.31315 6.22083 5.83398 10 5.83398C13.7792 5.83398 17.2167 7.31315 19.7542 9.72565C19.9083 9.87565 20 10.0882 20 10.3173C20 10.5465 19.9083 10.7548 19.7542 10.9048L17.6917 12.9673C17.5417 13.1173 17.3333 13.2132 17.1042 13.2132C16.8792 13.2132 16.6708 13.1215 16.5208 12.9757C15.8583 12.3632 15.1125 11.8423 14.3 11.434C14.025 11.2965 13.8333 11.0132 13.8333 10.684V8.09648C12.625 7.70898 11.3375 7.50065 10 7.50065Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_264_785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.1c1cac5cbe33825927ed782b48f293ae.svg";
export { ForwardRef as ReactComponent };